import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION22: PdfComponent = {
  type: 'section',
  id: 's22',
  title: '22. Entire Agreement',
  content: [
    {
      type: 'bulletList',
      id: 's22bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The parties agree that this Agreement constitutes the entire agreement and understanding between them and supersedes all previous agreements, understandings and arrangements between them, whether in writing or oral, in respect of its subject matter.',
        },
        {
          copy: 'Each party acknowledges that it has not entered into this Agreement in reliance on, and shall have no remedies in respect of, any representation or warranty that is not expressly set out in this Agreement. No party shall have any claim for innocent or negligent misrepresentation on the basis of any statement in this Agreement.',
        },
        {
          copy: 'Nothing in this Agreement purports to limit or exclude any liability for fraud.',
        },
      ],
      prefix: '22',
    },
  ],
};
